import { useState } from 'react'
import Modal from 'components/modal'

type Props = {
  isOpen: boolean
  closeModal: () => void
  token: string
  aggregatorName: string
}

const CopyTokenModal = ({
  isOpen,
  closeModal,
  token,
  aggregatorName,
}: Props) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(token)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Modal
      width={600}
      title="Token Generated"
      titleClassname="text-xl font-semibold text-gray-800"
      isOpen={isOpen}
      closeModal={closeModal}
      customStyle={{
        padding: '30px',
      }}
    >
      <div className="space-y-4">
        <p className="text-sm leading-relaxed text-gray-700">
          A new store token has been generated for{' '}
          <span className="font-semibold text-gray-900">
            {aggregatorName} Aggregator
          </span>{' '}
          . Please copy and save this token securely.
        </p>
        <p className="text-sm text-red-600">
          For security reasons, you won't be able to view it again.
        </p>

        {/* Token Display */}
        <div className="relative rounded-md border border-gray-300 bg-gray-100 p-3">
          <button
            type="button"
            onClick={handleCopy}
            className="float-right mb-1 ml-1.5 rounded-md bg-gray-700 px-2 py-1 text-sm text-gray-200 shadow-md hover:bg-gray-800"
            aria-label="Copy token"
          >
            {copied ? 'copied' : 'copy'}
          </button>
          <div className="w-full break-all text-xs text-gray-900">{token}</div>
        </div>
      </div>
    </Modal>
  )
}

export default CopyTokenModal
